import { pathOr } from 'ramda';

import { IJsonQuery } from 'shared/json_query';
import { ISearchOffersDesktopResponseV2Schema } from 'shared/repositories/commercial-search-offers/entities/search_offers_desktop_response_v2/SearchOffersDesktopResponseV2Schema';
import { IOffersData } from 'shared/types/offersData';

export function prepareOffers(response: ISearchOffersDesktopResponseV2Schema): IOffersData {
  return {
    ...response.data,
    aggregatedCount: pathOr(0, ['data', 'aggregatedCount'], response),
    avgPriceInformer: pathOr(null, ['data', 'avgPriceInformer'], response),
    breadcrumbs: pathOr([], ['data', 'breadcrumbs'], response),
    collections: pathOr(null, ['data', 'collections', 'items'], response),
    extendedOffersCount: pathOr(0, ['data', 'extendedOffersCount'], response),
    extensionTypes: pathOr([], ['data', 'extensionTypes'], response),
    fullUrl: pathOr('/', ['data', 'fullUrl'], response),
    jsonQuery: response.data.jsonQuery as IJsonQuery,
    mlRankingGuid: pathOr(null, ['data', 'mlRankingGuid'], response),
    mlRankingModelVersion: pathOr(null, ['data', 'mlRankingModelVersion'], response),
    newbuilding: pathOr(null, ['data', 'newbuilding'], response),
    newbuildingAdPath: pathOr(null, ['data', 'newbuildingAdPath'], response),
    newbuildingIdsForBuildersPromoSlider: pathOr([], ['data', 'newbuildingIdsForBuildersPromoSlider'], response),
    newbuildingSimilarOffersBlock: pathOr(null, ['data', 'newbuildingSimilarOffersBlock'], response),
    offerCount: pathOr(0, ['data', 'offerCount'], response),
    offersSerialized: pathOr([], ['data', 'offersSerialized'], response),
    queryString: pathOr('', ['data', 'queryString'], response),
    searchRequestId: pathOr('', ['data', 'searchRequestId'], response),
    searchUuid: pathOr(null, ['data', 'searchUuid'], response),
    seoData: response.data.seoData as IOffersData['seoData'],
    seoLinks: pathOr(null, ['data', 'seoLinks'], response),
    seoSchemas: pathOr(null, ['data', 'seoSchemas'], response),
    markedList: pathOr(null, ['data', 'markedList'], response),
    suggestOffersSerializedList: pathOr(null, ['data', 'suggestOffersSerializedList'], response),
    suggestionsQuery: pathOr(null, ['data', 'suggestionsQuery'], response),
    topHitsLinks: pathOr(null, ['data', 'topHitsLinks'], response),
  };
}
